import script from "./LoyaliteView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoyaliteView.vue?vue&type=script&setup=true&lang=js"

import "./LoyaliteView.vue?vue&type=style&index=0&id=ce40f166&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce40f166"]])

export default __exports__